export default "__VITE_ASSET__BVyZ4POa__"